import React, { useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import ActWiseView from '../Views/ActWiseView';
import DetailedView from '../Views/DetailedView';
import Modal from 'react-bootstrap/Modal';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'


export default function MainContainer() {
    const [aboutModal, setAboutModal] = useState(false)
    const [donateModal, setDonateModal] = useState(false)
    const handleAboutShow = () => setAboutModal(true)
    const handleDonateShow = () => setDonateModal(true)
    const handleAboutHide = () => setAboutModal(false)
    const handleDonateHide = () => setDonateModal(false)
    const [data, setData] = useState({})
    const [projectTitle, setProjectTitle] = useState('Project Title')
    const [metric, setMetric] = useState('words')
    const [amount, setAmount] = useState(80000)
    const [kanbanClass, setKanbanClass] = useState('non-print')
    const [backdrop, setBackdrop] = useState(false)


    let exportPDF = () => {
        setKanbanClass('print')
        setBackdrop(true)
        let input = document.getElementById('main-pg')
        domtoimage.toPng(input, {
            width: 2500
        })
        .then(function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            return img;
        })
        .then(function(img) {
            let pdf = new jsPDF({
                orientation: 'landscape',
            });
            const imgProps= pdf.getImageProperties(img);

            let pageHeight = pdf.internal.pageSize.getHeight();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(img, 'PNG', 0, 0, pdfWidth, pdfHeight);
            let numberofImgPages = Math.ceil(pdfHeight / pdf.internal.pageSize.getHeight())
            
            let cutAtForY = pageHeight;
            for (let imgSlice = 1; imgSlice < numberofImgPages; imgSlice++) {
                pdf.addPage();
                pdf.addImage(img, 'PNG', 0, -cutAtForY, pdfWidth, pdfHeight);
                cutAtForY += pageHeight;
            }

            pdf.addPage()
            autoTable(pdf, { html: '#print-table', theme: 'plain', useCss: true, columnStyles: {
                0: {cellWidth: pdf.internal.pageSize.getWidth() * 0.1 - 5},
                1: {cellWidth: pdf.internal.pageSize.getWidth() * 0.45 - 7},
                2: {cellWidth: pdf.internal.pageSize.getWidth() * 0.45 - 7},
              } })
            pdf.save('download.pdf');
            setKanbanClass('non-print')
            setBackdrop(false)
        })
        .catch(function (error) {
            setKanbanClass('non-print');
            setBackdrop(false)
            console.error('oops, something went wrong!', error);
        });
    }

    let updateMainData = (board, new_data) => {
        let new_board = {[board]: new_data}
        setData(prevData => ({...prevData, ...new_board}));
    }

    return (
        <div className="position-relative" style={{width: "100vw", overflow: "auto"}}>
            <nav className="floating-nav d-flex">
                <buttons className="floating-nav-item mx-1 p-2" onClick={exportPDF}>EXPORT</buttons>
                <buttons className="floating-nav-item mx-1 p-2" onClick={handleAboutShow}>ABOUT</buttons>
                <buttons className="floating-nav-item mx-1 p-2" onClick={handleDonateShow}>DONATE</buttons>
            </nav>
            <p className="floating-nav mt-2">crafted with 💖 by <a href="https://linktr.ee/booktools">@booktools</a></p>
            <header>
                <div className="p-3 text-center">
                    <h1>Hook the Book</h1>
                    <h2 style={{fontSize: "0.8rem"}} className="mb-3">A Save the Cat BeatSheet Template Playground</h2>
                    <div className="d-flex justify-content-center flex-column flex-md-row">
                        <input type="text" className="project-title mx-2" value={projectTitle} placeholder="Enter Project Title..." onChange={(e) => setProjectTitle(e.target.value)} />
                        <input type="number" className="amount mx-2" placeholder="Total Words/Pages" value={amount} onChange={(e) => setAmount(e.target.value)} />
                        <select name="metric" className="metric" value={metric} onChange={(e) => setMetric(e.target.value)}>
                            <option value="words">Words</option>
                            <option value="pages">Pages</option>
                        </select>

                    </div>
                </div>
            </header>

            <div className={kanbanClass} id="main-pg">
                <ActWiseView updateMainData={updateMainData} printState={kanbanClass} />
                <div class="d-none">
                    <DetailedView board={data} title={projectTitle} amount={amount} metric={metric} />
                </div>
            </div>

            <Modal
                show={aboutModal}
                onHide={handleAboutHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                <Modal.Body>
                    <div>
                        <h2 className="m-auto text-center">Hook the Book</h2>
                        <h6 className="m-auto text-center mb-4">Find me <a href="https://linktr.ee/booktools">@booktools</a></h6>
                        
                        <h5>The What</h5>
                        <p>
                            <strong>Hook the Book</strong> is a story plotting / outlining tool that is free and full of love potions. 
                            It is a child of Book Tools that is a collection of online tools for readers and writers to make book fun for all us all!
                        </p>

                        <h5>The How</h5>
                        <p>
                            According to the STC structure, your story can be divided into 3 acts and and
                            each act can then further be divided into 'beats' which act as main plot points or driving points of your story.
                            You will find description of each beat in the info icon at the top of each board.
                        </p>
                        <p>
                            <em>Remember: the STC structure is not word on the rock. It is popular because it works for some, 
                                but it isn't mandatory because it doesn't work for all. Oftentimes,
                            you will find that the beauty of your story lies in the divergence your mind crafts.
                             Only you know the best story to come out of you.
                            Do not be afraid to experiment, try, fail, succeed, and carve your own journey.</em>
                        </p>

                        <h5>The Have</h5>
                        <p>
                            <ul>
                                <li>
                                    Add notes for each beat
                                </li>
                                <li>
                                    Move the notes around
                                </li>
                                <li>
                                    Export to a PDF: (1) a snapshot of your board (2) a summarization of your plot parallel to your notes
                                </li>
                            </ul>
                        </p>
                        <h5>The Might Have</h5>
                        <p>
                            <ul>
                                <li>Support for saving work</li>
                                <li>Support to add/remove custom beats</li>
                                <li>Support for color-coordinated beatsheet</li>
                                <li>Support for structured note-taking</li>
                            </ul>
                        </p>
                        <h5>How can I support you, I want to ---</h5>
                        <p>
                            <em>--- said no one ever!</em> 
                            <br /><br/>
                            But it is incredibly sweet if you were thinking about it though.
                            You can buy me a coffee or a book here: <a href="https://www.buymeacoffee.com/booktools">buy-me-a-coffee</a>
                            <br/><br/>
                            If you are not in a position to contribute with money but still like what you use, that's no reason to worry, 
                            I would appreciate it so much even if you messaged me saying you're using it or shared it with your friends. 
                        </p>
                        
                        <h5>The People</h5>
                        <p>
                            Well, obviously Blake Snyder! You can find resources to Save the Cat here at the actual breathing website:  
                             <a href="https://savethecat.com"> savethecat.com</a>
                        </p>
                        <p>
                            This project could not have been free without the people who coded before me and made their projects free to
                            use for others. A shoutout to open source projects (I am unable to open-source this at the moment due to
                            personal security reasons), but a shout to them nevertheless <em>(please contribute to the their projects if you
                            have the bandwidth to!)</em>. A few of the projects used with this are:
                        </p>
                        <ul>
                            <li><a href="https://github.com/asseinfo/react-kanban/">react-kanban</a></li>
                            <li><a href="https://github.com/tsayen/dom-to-image">dom-to-image</a></li>
                            <li><a href="https://github.com/parallax/jsPDF">jspdf</a></li>
                            <li><a href="https://github.com/simonbengtsson/jsPDF-AutoTable/">jspdf-autotable</a></li>
                            <li>others: <a href="https://github.com/facebook/react">react</a>, <a href="https://github.com/react-bootstrap/react-bootstrap">react-bootstrap</a></li>
                        </ul>
                        <h6 className="m-auto text-center mt-4">Written with 💖</h6>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={donateModal}
                onHide={handleDonateHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                <Modal.Body>
                    <div>
                        <h2 className="m-auto text-center">Hook the Book</h2>
                        <h6 className="m-auto text-center mb-4">Find me <a href="https://twitter.com/booktools/">@booktools</a></h6>
                        <p>
                            Thank you so much for using <strong>Hook the Book</strong> and a <em>bigger thank you</em> for coming to this page.
                            Most of the tools under Book Tools are free for everyone use and I would love to keep it keep it that way.
                             A lot of time and effort goes into building and maintaining projects, 
                             and accepting contributions (in any amount) would help me build and maintain these projects with ease.
                        </p>
                        <p>
                            You can contribute here
                        </p>
                        <a href="https://www.buymeacoffee.com/booktools" target="_blank" className="d-block text-center mb-3"><img src="https://cdn.buymeacoffee.com/buttons/v2/default-green.png" alt="Buy Me A Coffee" style={{height: "60px", width: "217px"}} /></a>
                        {/* <a href="https://www.buymeacoffee.com/booktools" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/v2/default-green.png" alt="Buy Me A Coffee" style="height: 60px !important;width: 217px !important;" /></a> */}
                        <p>
                            If you are not in a position to contribute with money but still like what you use, that's super cool too, 
                            I would appreciate it so much even if you messaged me saying you're using it or shared it with your friends. 
                        </p>
                    </div>
                </Modal.Body>
            </Modal>

            {
                backdrop?
                <div style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, background: 'black', opacity: 0.5}}></div>
                :
                null
            }
        </div>
    )
}
